module.exports = __webpack_public_path__ + "static/media/digital-marketing.4127375a.png";